export default {
  title: "Aufgaben",
  description: "Verwalten Sie Ihre Hochzeitsaufgaben",
  taskList: "Aufgabenliste",
  addTask: "Aufgabe hinzufügen",
  editTask: "Aufgabe bearbeiten",
  deleteTask: "Aufgabe löschen",
  taskTitle: "Aufgabentitel",
  taskDescription: "Aufgabenbeschreibung",
  dueDate: "Fälligkeitsdatum",
  priorityLabel: "Priorität",
  category: "Kategorie",
  assignedTo: "Zugewiesen an",
  notes: "Notizen",
  subtasks: "Teilaufgaben",
  addSubtask: "Teilaufgabe hinzufügen",
  noTasks: "Keine Aufgaben gefunden",
  addFirstTask: "Fügen Sie Ihre erste Aufgabe hinzu",
  taskDetails: "Aufgabendetails",
  save: "Speichern",
  cancel: "Abbrechen",
  delete: "Löschen",
  edit: "Bearbeiten",
  complete: "Abschließen",
  incomplete: "Unvollständig",
  confirmDelete: "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
  confirmDeleteTask: "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
  taskAdded: "Aufgabe erfolgreich hinzugefügt",
  taskUpdated: "Aufgabe erfolgreich aktualisiert",
  taskDeleted: "Aufgabe erfolgreich gelöscht",
  taskCreated: "Aufgabe erfolgreich erstellt",
  taskCompleted: "Aufgabe erfolgreich abgeschlossen",
  taskUncompleted: "Aufgabe als unvollständig markiert",
  totalTasks: "{{count}} Aufgaben",
  pending: "{{count}} ausstehend",
  completed: "{{count}} abgeschlossen",
  search: "Aufgaben suchen",
  "tasks.dueDate": "Fälligkeitsdatum",

  view: {
    list: "Liste",
    kanban: "Kanban",
    boardView: "Board-Ansicht",
    calendarView: "Kalenderansicht",
    listView: "Listenansicht"
  },

  priority: {
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    urgent: "Dringend"
  },

  status: {
    todo: "Zu erledigen",
    pending: "Ausstehend",
    inProgress: "In Bearbeitung",
    in_progress: "In Bearbeitung",
    completed: "Abgeschlossen",
    cancelled: "Abgebrochen",
    done: "Erledigt",
    overdue: "Überfällig"
  },

  statuses: {
    pending: "Ausstehend",
    in_progress: "In Bearbeitung",
    completed: "Abgeschlossen",
    cancelled: "Abgebrochen"
  },

  categories: {
    planning: "Planung",
    venue: "Veranstaltungsort",
    catering: "Catering",
    flowers: "Blumen",
    photography: "Fotografie",
    music: "Musik",
    attire: "Kleidung",
    invitations: "Einladungen",
    transportation: "Transport",
    decoration: "Dekoration",
    legal: "Rechtliches",
    beauty: "Schönheit",
    other: "Sonstiges",
    ceremony: "Zeremonie",
    reception: "Empfang",
    vendors: "Dienstleister",
    guests: "Gäste",
    honeymoon: "Flitterwochen"
  },

  filters: {
    title: "Filter",
    all: "Alle Aufgaben",
    pending: "Ausstehend",
    completed: "Abgeschlossen",
    overdue: "Überfällig",
    today: "Für heute",
    thisWeek: "Diese Woche",
    thisMonth: "Diesen Monat",
    status: "Status",
    category: "Kategorie",
    dueDate: "Fälligkeitsdatum",
    priority: "Priorität",
    priorityLabel: "Priorität",
    search: "Aufgabe suchen",
    sortBy: "Sortieren nach",
    clear: "Filter löschen",
    reset: "Zurücksetzen",
    assignee: "Zugewiesen an",
    apply: "Anwenden",
    previous: "Zurück",
    next: "Weiter",
    options: {
      title: "Titel",
      dueDate: "Fälligkeitsdatum",
      priority: "Priorität",
      status: "Status"
    }
  },

  sort: {
    dueDate: "Fälligkeitsdatum",
    priorityLabel: "Priorität",
    status: "Status",
    title: "Titel",
    created: "Erstellungsdatum"
  },

  dueDateWarning: "Fälligkeitsdatum nähert sich",
  overdue: "Überfällig",
  dueToday: "Fällig heute",
  dueTomorrow: "Fällig morgen",
  dueThisWeek: "Fällig diese Woche",
  dueNextWeek: "Fällig nächste Woche",
  dueThisMonth: "Fällig diesen Monat",
  dueNextMonth: "Fällig nächsten Monat",
  noDueDate: "Kein Fälligkeitsdatum",
  progress: "Fortschritt",
  completionRate: "Abschlussquote",
  completedTasks: "Abgeschlossene Aufgaben",
  pendingTasks: "Ausstehende Aufgaben",
  overdueTasks: "Überfällige Aufgaben",
  taskProgress: "Aufgabenfortschritt",
  milestones: "Meilensteine",
  createMilestone: "Meilenstein erstellen",
  milestoneTitle: "Meilensteintitel",
  milestoneDate: "Meilensteindatum",
  milestoneDescription: "Meilensteinbeschreibung",
  milestoneAdded: "Meilenstein erfolgreich hinzugefügt",
  milestoneUpdated: "Meilenstein erfolgreich aktualisiert",
  milestoneDeleted: "Meilenstein erfolgreich gelöscht",
  timeline: "Zeitplan",
  ganttChart: "Gantt-Diagramm",
  searchPlaceholder: "Suchen nach Titel oder Beschreibung",
  noResults: "Keine Aufgaben entsprechen Ihrer Suche",
  clearSearch: "Suche löschen",
  export: "Exportieren",
  import: "Importieren",
  exportTasks: "Aufgaben exportieren",
  importTasks: "Aufgaben importieren",
  template: "Vorlage",
  useTemplate: "Vorlage verwenden",
  weddingPlanningTemplate: "Hochzeitsplanungsvorlage",
  customTemplate: "Benutzerdefinierte Vorlage",
  templateApplied: "Vorlage erfolgreich angewendet",
  bulkActions: "Massenaktionen",
  selectAll: "Alles auswählen",
  deselectAll: "Alles abwählen",
  markCompleted: "Als erledigt markieren",
  markPending: "Als ausstehend markieren",
  changeCategory: "Kategorie ändern",
  changePriority: "Priorität ändern",
  bulkDelete: "Massenlöschung",
  selectedTasks: "{{count}} Aufgaben ausgewählt",
  bulkUpdateSuccess: "{{count}} Aufgaben erfolgreich aktualisiert",
  bulkDeleteSuccess: "{{count}} Aufgaben erfolgreich gelöscht",
  confirmBulkDelete: "Sind Sie sicher, dass Sie {{count}} Aufgaben löschen möchten?",
  dependencies: "Abhängigkeiten",
  addDependency: "Abhängigkeit hinzufügen",
  dependsOn: "Hängt ab von",
  blockedBy: "Blockiert durch",
  blocks: "Blockiert",
  noDependencies: "Keine Abhängigkeiten",
  attachments: "Anhänge",
  addAttachment: "Anhang hinzufügen",
  uploadFile: "Datei hochladen",
  downloadFile: "Datei herunterladen",
  deleteFile: "Datei löschen",
  fileUploaded: "Datei erfolgreich hochgeladen",
  fileDeleted: "Datei erfolgreich gelöscht",
  comments: "Kommentare",
  addComment: "Kommentar hinzufügen",
  commentPlaceholder: "Kommentar hinzufügen...",
  commentAdded: "Kommentar erfolgreich hinzugefügt",
  commentUpdated: "Kommentar erfolgreich aktualisiert",
  commentDeleted: "Kommentar erfolgreich gelöscht",
  noComments: "Noch keine Kommentare",
  notifications: "Benachrichtigungen",
  reminders: "Erinnerungen",
  setReminder: "Erinnerung setzen",
  reminderTime: "Erinnerungszeit",
  reminderSet: "Erinnerung erfolgreich gesetzt",
  reminderDeleted: "Erinnerung erfolgreich gelöscht",
  emailNotifications: "E-Mail-Benachrichtigungen",
  pushNotifications: "Push-Benachrichtigungen",
  recurring: "Wiederkehrend",
  recurringTask: "Wiederkehrende Aufgabe",
  recurrencePattern: "Wiederholungsmuster",
  daily: "Täglich",
  weekly: "Wöchentlich",
  monthly: "Monatlich",
  yearly: "Jährlich",
  custom: "Benutzerdefiniert",
  endDate: "Enddatum",
  occurrences: "Vorkommen",
  recurringTaskCreated: "Wiederkehrende Aufgabe erfolgreich erstellt",
  analytics: "Analytik",
  productivity: "Produktivität",
  timeTracking: "Zeiterfassung",
  startTimer: "Timer starten",
  stopTimer: "Timer stoppen",
  timeSpent: "Verbrachte Zeit",
  estimatedTime: "Geschätzte Zeit",
  actualTime: "Tatsächliche Zeit",
  efficiency: "Effizienz",
  taskVelocity: "Aufgabengeschwindigkeit",
  burndownChart: "Burndown-Diagramm",
  velocityChart: "Geschwindigkeitsdiagramm",

  form: {
    title: "Aufgabentitel",
    description: "Aufgabenbeschreibung",
    category: "Kategorie",
    priority: "Priorität",
    status: "Status",
    dueDate: "Fälligkeitsdatum",
    new: "Neue Aufgabe",
    edit: "Aufgabe bearbeiten",
    titlePlaceholder: "Aufgabentitel",
    descriptionPlaceholder: "Aufgabenbeschreibung",
    dueDatePlaceholder: "Fälligkeitsdatum",
    categoryPlaceholder: "Kategorie",
    priorityPlaceholder: "Priorität",
    statusPlaceholder: "Status",
    assignedTo: "Zugewiesen an",
    assignedToPlaceholder: "Verantwortlicher",
    notes: "Notizen",
    notesPlaceholder: "Zusätzliche Notizen",
    submit: "Speichern",
    cancel: "Abbrechen",
    name: "Name",
    assignee: "Zugewiesen an",
    confirmCancel: "Sind Sie sicher, dass Sie abbrechen möchten? Ungespeicherte Änderungen gehen verloren.",
    errors: {
      titleRequired: "Der Titel ist erforderlich",
      descriptionRequired: "Die Beschreibung ist erforderlich",
      submitFailed: "Fehler beim Speichern der Aufgabe",
      titleMinLength: "Der Titel muss mindestens 3 Zeichen enthalten",
      statusRequired: "Der Status ist erforderlich",
      priorityRequired: "Die Priorität ist erforderlich",
      categoryRequired: "Die Kategorie ist erforderlich",
      dueDateRequired: "Das Fälligkeitsdatum ist erforderlich"
    }
  },

  actions: {
    edit: "Bearbeiten",
    delete: "Löschen",
    complete: "Abschließen",
    moveTask: "Aufgabe verschieben"
  },

  errors: {
    moveTask: "Fehler beim Verschieben der Aufgabe",
    loadFailed: "Fehler beim Laden der Aufgaben",
    addFailed: "Fehler beim Hinzufügen der Aufgabe",
    updateFailed: "Fehler beim Aktualisieren der Aufgabe",
    deleteFailed: "Fehler beim Löschen der Aufgabe",
    submit: "Fehler beim Senden der Aufgabe"
  },

  messages: {
    createSuccess: "Aufgabe erfolgreich hinzugefügt",
    updateSuccess: "Aufgabe erfolgreich aktualisiert",
    deleteSuccess: "Aufgabe erfolgreich gelöscht",
    deleteConfirm: "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
    error: "Ein Fehler ist aufgetreten"
  },

  modal: {
    title: "Aufgabe",
    edit: "Aufgabe bearbeiten",
    delete: "Aufgabe löschen",
    confirmDelete: "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?"
  },

  sharing: {
    title: "Aufgabenliste teilen",
    share: "Teilen",
    success: "Aufgabenliste erfolgreich geteilt",
    readOnly: "Schreibgeschützt",
    edit: "Bearbeiten",
    defaultMessage: "Ich habe eine Aufgabe mit Ihnen geteilt",
    recipientEmail: "E-Mail des Empfängers",
    emailPlaceholder: "Geben Sie die E-Mail des Empfängers ein",
    recipientName: "Name des Empfängers",
    namePlaceholder: "Geben Sie den Namen des Empfängers ein",
    message: "Nachricht",
    messagePlaceholder: "Geben Sie Ihre Nachricht ein",
    accessLevel: "Zugriffsebene"
  },

  demoTasks: {
    bookVenue: {
      title: "Veranstaltungsort buchen",
      description: "Finden und buchen Sie den idealen Ort für die Zeremonie und den Empfang"
    },
    orderInvitations: {
      title: "Einladungen bestellen",
      description: "Einladungen für die Gäste auswählen und bestellen"
    },
    bookCaterer: {
      title: "Caterer buchen",
      description: "Caterer für das Hochzeitsessen auswählen und buchen"
    },
    chooseDress: {
      title: "Kleid auswählen",
      description: "Finden Sie das perfekte Brautkleid"
    },
    bookPhotographer: {
      title: "Fotograf buchen",
      description: "Fotograf auswählen und buchen, um Ihren Tag festzuhalten"
    },
    chooseRings: {
      title: "Ringe auswählen",
      description: "Finden Sie die perfekten Ringe für Ihr Paar"
    }
  }
};
